import { render, staticRenderFns } from "./NoticeModal.vue?vue&type=template&id=8f57542e&scoped=true"
import script from "./NoticeModal.vue?vue&type=script&lang=js"
export * from "./NoticeModal.vue?vue&type=script&lang=js"
import style0 from "./NoticeModal.vue?vue&type=style&index=0&id=8f57542e&lang=scss"
import style1 from "./NoticeModal.vue?vue&type=style&index=1&id=8f57542e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f57542e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f57542e')) {
      api.createRecord('8f57542e', component.options)
    } else {
      api.reload('8f57542e', component.options)
    }
    module.hot.accept("./NoticeModal.vue?vue&type=template&id=8f57542e&scoped=true", function () {
      api.rerender('8f57542e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modal/NoticeModal.vue"
export default component.exports